export default "__VITE_ASSET__DGxXQEin__"